import { debounce } from 'lodash-es';
import { useEffect, useRef } from 'react';

import { TASK_CONST } from '@/constant';
import { useUpdateFrameWorkStateMutation } from '@/hook';
import {
  usePcdRenderingStore,
  useTaskFrameStore,
  useToolPermissionStore,
} from '@/store';

const Review = () => {
  const { currentFrame, isAssignedReviewMe, isValidFrameDetail } =
    useTaskFrameStore();
  const { isPlaying } = usePcdRenderingStore();
  const { setPermission } = useToolPermissionStore();

  const isAssignedMe = isAssignedReviewMe();

  const { mutateAsync: updateFrameWorkState } =
    useUpdateFrameWorkStateMutation();

  const isPending = useRef(false);

  useEffect(() => {
    if (isPlaying) return;

    setPermission({
      labeling: {
        readable: true,
        updatable: false,
        acceptable: false,
      },
      labelingReview: {
        readable: true,
        updatable: false,
        acceptable: isAssignedMe,
      },
      preAnnotation: {
        acceptable: false,
      },
      aiAssist: {
        acceptable: false,
      },
    });

    if (!isAssignedMe || isPending.current || !isValidFrameDetail()) return;

    isPending.current = true;

    updateFrameWorkState({
      frameSeq: currentFrame!.frameSeq,
      taskID: currentFrame!.taskID,
      currentWorkState: currentFrame!.workState,
      workState: TASK_CONST.TASK_FRAME_WORKSTATE.REVIEWING,
    })
      .catch(error => {
        console.error('Failed to update work state:', error);
      })
      .finally(() => {
        debounce(() => (isPending.current = false), 1000)();
      });
  }, [currentFrame, isAssignedMe]);

  return <></>;
};

export default Review;
